import { AuthenticationMethodType } from '@mc-alberta/types';
import { getConsumerId } from './utils/getConsumerId';
import merge from 'lodash.merge';
export function getLookupKpiMeta(lookupParams, lookupResponse) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const resourceData = resourceCommonData(lookupParams);
    if (lookupResponse === null || lookupResponse === void 0 ? void 0 : lookupResponse.authenticationMethods) {
        const authenticationMethods = lookupResponse === null || lookupResponse === void 0 ? void 0 : lookupResponse.authenticationMethods;
        const hasType = (type) => authenticationMethods.some((method) => method.authenticationMethodType === type);
        const consentSMSAuthVerificationSupported = hasType(AuthenticationMethodType.SMS_OTP);
        const consentEMAILAuthVerificationSupported = hasType(AuthenticationMethodType.EMAIL_OTP);
        const fidoMethod = authenticationMethods.find((method) => {
            return method.authenticationMethodType === AuthenticationMethodType.FIDO2;
        });
        const consumerData = ((_a = lookupParams.accountReference) === null || _a === void 0 ? void 0 : _a.consumerIdentity) && {
            consumerVerificationData: {
                fidoAuthVerificationSupported: !!fidoMethod
            }
        };
        const cardData = ((_b = lookupParams.accountReference) === null || _b === void 0 ? void 0 : _b.srcDigitalCardId) && {
            cardVerificationData: {
                lvlrAuthVerificationSupported: hasType(AuthenticationMethodType.LVLR),
                fidoAuthVerificationSupported: hasType(AuthenticationMethodType.FIDO2),
                threeDsAuthVerificationSupported: hasType(AuthenticationMethodType.THREE_DS),
                consentAuthVerificationSupported: consentEMAILAuthVerificationSupported || consentSMSAuthVerificationSupported,
                consentSMSAuthVerificationSupported,
                consentEMAILAuthVerificationSupported
            }
        };
        const authenticationData = (lookupResponse === null || lookupResponse === void 0 ? void 0 : lookupResponse.authenticationMethods) && {
            multiFactorAuthenticatorData: {
                dasAuthenticationSessionId: (_d = (_c = fidoMethod === null || fidoMethod === void 0 ? void 0 : fidoMethod.methodAttributes) === null || _c === void 0 ? void 0 : _c.extAuthProviderMetaData) === null || _d === void 0 ? void 0 : _d.authSessionId,
                dasClientId: (_f = (_e = fidoMethod === null || fidoMethod === void 0 ? void 0 : fidoMethod.methodAttributes) === null || _e === void 0 ? void 0 : _e.extAuthProviderMetaData) === null || _f === void 0 ? void 0 : _f.clientId,
                isSupressIDV: (_h = (_g = fidoMethod === null || fidoMethod === void 0 ? void 0 : fidoMethod.methodAttributes) === null || _g === void 0 ? void 0 : _g.extAuthProviderMetaData) === null || _h === void 0 ? void 0 : _h.isSuppressIDV
            }
        };
        return merge(resourceData, { consumerData, cardData, authenticationData });
    }
    return resourceData;
    /**
     * Get resource common data
     */
    function resourceCommonData(lookupParams) {
        var _a, _b, _c, _d, _e, _f, _g;
        const consumerData = ((_a = lookupParams.accountReference) === null || _a === void 0 ? void 0 : _a.consumerIdentity) && {
            consumerId: getConsumerId(lookupParams.idLookupSessionId),
            identityType: (_c = (_b = lookupParams.accountReference) === null || _b === void 0 ? void 0 : _b.consumerIdentity) === null || _c === void 0 ? void 0 : _c.identityType,
            consumerVerificationData: {
                consumerAuthRequestReason: (_d = lookupParams.authenticationContext.authenticationReasons) === null || _d === void 0 ? void 0 : _d[0]
            }
        };
        const cardData = ((_e = lookupParams.accountReference) === null || _e === void 0 ? void 0 : _e.srcDigitalCardId) && {
            cardId: (_f = lookupParams.accountReference) === null || _f === void 0 ? void 0 : _f.srcDigitalCardId,
            cardVerificationData: {
                cardAuthRequestReason: (_g = lookupParams.authenticationContext.authenticationReasons) === null || _g === void 0 ? void 0 : _g[0]
            }
        };
        return { consumerData, cardData };
    }
}
